<template>
  <section class="carousel">
    <div class="carousel-container">
      <div class="carousel-wrapper">
        <div class="carousel-content">
          <div class="carousel-slides">
            <transition name="fade">
              <div v-if="currentSlide === 0" key="slide1" class="slide">
                <div class="image-pair">
                  <img :src="images[0].url" :alt="images[0].alt" />
                  <img :src="images[1].url" :alt="images[1].alt" />
                </div>
                <div class="slide-title">
                  2025年5月10日参加国际台球博览会
                </div>
              </div>
              <div v-else key="slide2" class="slide">
                <div class="image-pair">
                  <img :src="images[2].url" :alt="images[2].alt" />
                  <img :src="images[3].url" :alt="images[3].alt" />
                </div>
                <div class="slide-title">
                  2025年6月14日冠名广州台球协会举办斯诺克团体赛"奇点杯"
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <button class="carousel-button prev" @click="prev" :disabled="isAtStart">
        <span class="arrow">&#8249;</span>
      </button>
      <button class="carousel-button next" @click="next" :disabled="isAtEnd">
        <span class="arrow">&#8250;</span>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Carousel',
  data() {
    return {
      currentSlide: 0,
      images: [
        { url: require('../assets/Carousel/1.png'), alt: '展示图片1' },
        { url: require('../assets/Carousel/2.png'), alt: '展示图片2' },
        { url: require('../assets/Carousel/3.png'), alt: '展示图片3' },
        { url: require('../assets/Carousel/4.png'), alt: '展示图片4' }
      ]
    }
  },
  computed: {
    isAtStart() {
      return this.currentSlide === 0;
    },
    isAtEnd() {
      return this.currentSlide === 1;
    }
  },
  methods: {
    prev() {
      if (!this.isAtStart) {
        this.currentSlide = 0;
      }
    },
    next() {
      if (!this.isAtEnd) {
        this.currentSlide = 1;
      }
    }
  }
}
</script>

<style scoped>
.carousel {
  padding: 4rem 5%;
  background-color: #f8f9fa;
}

.carousel-container {
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  padding: 0 15px;
}

.carousel-wrapper {
  position: relative;
  min-height: 400px;
  width: 100%;
}

.carousel-content {
  width: 100%;
  text-align: center;
  padding: 0 20px;
  position: relative;
}

.carousel-slides {
  position: relative;
  min-height: 650px;  /* 给足够的空间显示图片和文字 */
}

.slide {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  width: 100%;
}

.image-pair {
  width: 100%;
  display: flex;
  gap: 30px;
  justify-content: center;
}

.slide-title {
  text-align: center;
  font-size: 1.2rem;
  color: #333;
  font-weight: 1000;
  padding: 10px;
  margin: 0;
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
  position: absolute;
  width: 100%;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.image-pair {
  display: flex;
  gap: 30px;
  justify-content: center;
  margin-bottom: 1rem;
}

.image-pair img {
  max-width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.image-pair img:hover {
  transform: scale(1.02);
}

.carousel-button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.9);
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 2;
}

.carousel-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.carousel-button.prev {
  left: -20px;
}

.carousel-button.next {
  right: -20px;
}

.arrow {
  font-size: 24px;
  color: #333;
  line-height: 1;
}

@media (max-width: 1024px) {
  .carousel {
    padding: 2rem 3%;
  }

  .carousel-wrapper {
    min-height: 300px;
  }

  .carousel-slides {
    min-height: 450px;
  }

  .image-pair {
    gap: 15px;
  }

  .slide-title {
    font-size: 1.1rem;
    padding: 8px;
  }
}

@media (max-width: 768px) {
  .carousel {
    padding: 1.5rem 2%;
  }

  .carousel-wrapper {
    min-height: 250px;
  }

  .carousel-slides {
    min-height: 400px;
  }

  .image-pair {
    flex-direction: column;
    gap: 10px;
  }

  .image-pair img {
    width: 100%;
    height: auto;
  }
  
  .carousel-button {
    width: 30px;
    height: 30px;
    background: rgba(255, 255, 255, 0.95);
  }

  .carousel-button.prev {
    left: 5px;
  }

  .carousel-button.next {
    right: 5px;
  }
  
  .arrow {
    font-size: 18px;
  }

  .slide-title {
    font-size: 1rem;
    padding: 6px;
    line-height: 1.4;
  }
}

@media (max-width: 480px) {
  .carousel {
    padding: 1rem 1%;
  }

  .carousel-wrapper {
    min-height: 200px;
  }

  .carousel-slides {
    min-height: 350px;
  }

  .image-pair img {
    width: 100%;
    height: auto;
  }

  .carousel-button {
    width: 25px;
    height: 25px;
  }

  .arrow {
    font-size: 16px;
  }

  .slide-title {
    font-size: 0.9rem;
    padding: 4px;
  }
}

.slide-title {
  font-size: 1.2rem;
  color: #333;
  margin-top: 1rem;
  font-weight: 1000;
  text-align: center;
}
</style>
